import { UserBaseV2 } from '../user';

export const AnnotationSchema: { startTime: 'date'; durationMins: 'int' } = {
  startTime: 'date',
  durationMins: 'int',
};

export type AnnotationDXObjectType = 'metric' | 'funnel' | '';
export interface AnnotationAnalytics {
  /*
   * id will be empty string if this is a new annotation
   */
  id: string;
  label: string;
  descriptionLength: number;
  description: string;
  startTime: Date;
  /*
   * The number of mins since start time. Will be 0 if not a range
   */
  durationMins: number;
  user: UserBaseV2;
  // the frequency applied to the parent dx object
  dxObjectFrequency: string;
  dxObjectType: AnnotationDXObjectType;
  dxObjectId: string;
  global: boolean;
}

export interface AnnotationDeletedAnalytics {
  id: string;
  user: UserBaseV2;
}

export interface BulkAnnotationDeletedAnalytics {
  ids: string[];
  user: UserBaseV2;
}
